import DepartmentUserForm from '../../components/Users/DepartmentUser'

const AddDepartmentUser = () => {
  return (
    <div>
      <DepartmentUserForm></DepartmentUserForm>
    </div>
  )
}

export default AddDepartmentUser